export default 'M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24M3 12c0-4.96 4.04-9 9-9v18c-4.96 0-9-4.04-9-9';